import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/Systemische Beratung in Dresden - Madlin Firme.png';

const Footer = () => {
  return (
    <footer
      className="mt-10"
      style={{
        backgroundColor: 'var(--color-bg-secondary)',
        borderTop: '1px solid var(--color-border-subtle)',
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand / Kontakt */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div
                className="flex items-center justify-center"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 'var(--radius-lg)',
                  backgroundColor: 'var(--color-surface-1)',
                  border: '1px solid var(--color-border-subtle)',
                  boxShadow: 'var(--shadow-sm)',
                }}
              >
                <img src={Logo} alt="Logo" className="w-8 h-8" />
              </div>

              <span
                className="font-serif text-xl"
                style={{ color: 'var(--color-text-primary)' }}
              >
                Madlin Firme
              </span>
            </div>

            <p className="mb-5" style={{ color: 'var(--color-text-secondary)' }}>
              Systemische Beratung &amp; Begleitung
            </p>

            <div className="space-y-2 text-sm" style={{ color: 'var(--color-text-muted)' }}>
              <p>Tel.: 0157 / 53557860</p>
              <p>
                E-Mail:{' '}
                <a
                  href="mailto:kontakt@malneudenken.de"
                  style={{ color: 'var(--color-link-base)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-link-hover)')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--color-link-base)')}
                >
                  kontakt@malneudenken.de
                </a>
              </p>
            </div>

            {/* Optional: kleiner CTA */}
            <div className="mt-6">
              <a
                href="#contact"
                className="btn btn-accent"
                style={{
                  borderRadius: 'var(--radius-pill)',
                  padding: '0.65rem 1rem',
                }}
              >
                Termin anfragen
              </a>
            </div>
          </div>

          {/* Schnelllinks */}
          <div>
            <h3 className="font-serif text-lg mb-4" style={{ color: 'var(--color-text-primary)' }}>
              Schnellzugriff
            </h3>

            <ul className="space-y-2">
              {[
			  { href: '/#about', label: 'Über mich' },
			  { href: '/#services', label: 'Angebot' },
			  { href: '/#contact', label: 'Kontakt' },
			  { href: '/#faq', label: 'Häufige Fragen' },
			].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    style={{
                      color: 'var(--color-text-secondary)',
                      textDecoration: 'none',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-link-hover)')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h3 className="font-serif text-lg mb-4" style={{ color: 'var(--color-text-primary)' }}>
              Rechtliches
            </h3>

            <ul className="space-y-2">
              <li>
                <Link
                  to="/impressum"
                  style={{ color: 'var(--color-text-secondary)', textDecoration: 'none' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-link-hover)')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  style={{ color: 'var(--color-text-secondary)', textDecoration: 'none' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--color-link-hover)')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--color-text-secondary)')}
                >
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="mt-10 pt-8"
          style={{
            borderTop: '1px solid var(--color-border-subtle)',
          }}
        >
          <div className="text-center text-sm" style={{ color: 'var(--color-text-muted)' }}>
            <p>© 2026 Madlin Firme – Alle Rechte vorbehalten</p>
            <p className="mt-2">
              Mit Liebe zum Detail entwickelt • Design &amp; Code: Handgefertigt für eine persönliche Note
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;